import { render, staticRenderFns } from "./VCompanyDataHistory.vue?vue&type=template&id=1d881dae&lang=pug"
import script from "./VCompanyDataHistory.vue?vue&type=script&lang=ts"
export * from "./VCompanyDataHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports